<template>
  <form @submit.prevent="$emit('submit')" class="col mt-lg-0 plan-information">
    <div class="mb-5">
      <step-title
        title="Informações de preço"
        description="Informe como você deseja monetizar a sua assinatura."
      />
    </div>
    <!-- <bp-select
      class="mt-6"
      v-model="form.currency"
      id="currency"
      label="Moeda base"
      placeholder="Selecione a moeda..."
      select
      :options="[{ id: 'BRL', name: 'Real Brasileiro' }]"
      :errors="errors.currency"
      description="Em caso de venda para outros países, usaremos esta moeda como base para a
      conversão."
    /> -->

    <div class="mb-0 mt-6">
      Formas de pagamento<span class="text-danger">*</span>
    </div>
    <span class="small-text text-secondary">
      Escolha como será a estratégia de pagamento.
    </span>
    <b-form-checkbox-group
      class="mt-3"
      id="payment"
      v-model="form.payment_methods_ids"
    >
      <div
        v-for="(method, i) in _paymentMethods"
        :key="i"
        class="d-flex align-items-center"
      >
        <b-form-checkbox :value="method.id">{{ method.name }}</b-form-checkbox>
        <bp-tooltip
          v-if="
            ['two_credit_card'].includes(method.code) ||
              ['card_pix'].includes(method.code)
          "
          text="Ao selecionar esse método de pagamento, a opção de período de teste
            do produto será desabilitada. Esse tipo de pagamento também não
            gerará assinatura do produto."
        >
          <bp-icon
            size="12"
            class="text-negative-500"
            icon="fa fa-circle-exclamation"
          />
        </bp-tooltip>
      </div>
    </b-form-checkbox-group>

    <bp-select
      class="mt-5"
      v-model="form.warranty"
      id="warranty"
      label="Garantia do produto"
      placeholder="Selecionar..."
      select
      :options="warranties"
      :errors="errors.warranty"
      required
      description="Este é o prazo que o cliente tem para pedir reembolso do produto. No
      Brasil, o prazo mínimo é de 7 dias e na União Europeia, de 15 dias."
    />
  </form>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    plans: {
      type: Array,
      default: () => []
    },
    form: {
      type: Object,
      default: null
    },
    errors: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState("product", ["warranties", "currencies", "paymentMethods"]),
    _paymentMethods() {
      const order = [1, 4, 2, 3, 34];

      const orderedPaymentMethods = [...this.paymentMethods].sort(
        (a, b) => order.indexOf(a.id) - order.indexOf(b.id)
      );

      return orderedPaymentMethods;
    }
  },
  mounted() {
    this.$store.dispatch("product/getPaymentMethods").then();
    this.$store.dispatch("product/getCurrency").then();
  }
};
</script>
